export const agreement = {
  termsLink: "https://edwealth.ai/terms_of_service.html",
  privacyLink: "https://edwealth.ai/privacy_policy.html",
};

export const socialLinks = {
  twitter: "https://x.com/EdWealth_AI",
  // telegram: "https://t.me/edgentech",
  youtube: "https://www.youtube.com/channel/UC7OZRYYZqPWTM7DZmJ1UUnA",
  gitbook: "https://gitbook.edgen.tech",
};
